import React, { CSSProperties, FC, ReactNode, useEffect, useId } from "react";
import F7 from "../../../utils/F7";

const ListBlock: FC<{
  sortable?: boolean;
  title?: string;
  children: ReactNode;
  style?: CSSProperties;
}> = ({ sortable, title, children, style }) => {
  const id = useId().replaceAll(":", "");

  useEffect(() => {
    if (sortable) {
      F7.sortableOpen(`#${id}`);
    } else {
      F7.sortableClose(`#${id}`);
    }
  }, [id, sortable]);

  return (
    <div
      id={id}
      className={sortable ? "list-block sortable" : "list-block"}
      style={{
        marginTop: 10,
        marginBottom: 20,
        ...style,
      }}
    >
      {title ? (
        <div
          className="content-block-title"
          style={{
            marginTop: 10,
          }}
        >
          {title}
        </div>
      ) : null}
      <ul>{children}</ul>
    </div>
  );
};

export default ListBlock;
